// extracted by mini-css-extract-plugin
export default {"title":"t5-z","warning":"u5-z","sizeOptionsLegendText":"v5-z"};